<template>
  <b-modal
    class="modal"
    id="language-modal"
    style="display: block;"
    :hide-footer="true"
    :hide-header="true"
  >
    <div class="language-selm edit-profile">
      <div class="modal-header">
        <h4 class="modal-title mb-0">{{ _T('Language') }}</h4>
        <button
          type="button"
          class="close"
          @click="$bvModal.hide('language-modal')"
        >
          ×
        </button>
      </div>
      <div class="modal-body">
        <div class="radio-btns">
          <ul v-if="availableLanguages">
            <li v-for="(language, index) in availableLanguages" :key="index">
              <label for="edo-ani">
                <input
                  class="radio_animated"
                  id="edo-ani"
                  type="radio"
                  name="rdo-ani"
                  v-model="selectedLanguage"
                />
                <div class="d-flex">
                  <img
                    :src="'/images/account/' + language.icon_code + '.png'"
                    alt=""
                    class="img-fluid"
                  />
                  <h6>{{ _T_DB(language, 'name') }}</h6>
                </div>
              </label>
            </li>
          </ul>
          <p v-else>{{ _T('No Languages found') }}</p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LanguagePicker',
  data() {
    return {
      selectedLanguage: 'en',
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'availableLanguages',
      'currentLanguage'
    ]),
  },
}
</script>

<style lang="scss">
#language-modal {
  .modal-dialog{
    position: absolute;
    width: 100%;
    margin: 0;
    top: unset;
    bottom: 0;
    .modal-content{
      border: none;
      .language-selm {
    &.edit-profile {
      .modal-header {
        padding-bottom: calc(
          20px + (34 - 20) * ((100vw - 320px) / (1920 - 320))
        );
        border-bottom: 1px solid $light-border;
      }
    }
    .modal-dialog,
    .fade {
      transition: none !important;
      transform: none !important;
      margin: 0;
      .modal-content {
        border: none;
        border-radius: 0.3rem 0.3rem 0 0;
      }
    }
    .modal-body {
      padding: calc(20px + (34 - 20) * ((100vw - 320px) / (1920 - 320))) !important;
      .radio-btns {
        ul {
          li {
            display: block;
            padding: 20px 0;
            &:first-child {
              padding-top: 0;
            }
            &:last-child {
              padding-bottom: 0;
            }
            + li {
              border-top: $px1 solid $light-border;
              label {
                .d-flex {
                  img {
                    width: $px18;
                  }
                }
              }
            }
            label {
              display: block;
              margin-bottom: 0;
              .radio_animated {
                &:after {
                  border: $px2 solid $font-color;
                  top: 0;
                }
                &:before {
                  top: $px4;
                }
                &:checked {
                  &:after {
                    border-color: $color-primary;
                  }
                }
              }
              .d-flex {
                align-items: center;
              }
              h6 {
                display: inline-block;
                margin-bottom: 0;
                line-height: $px17;
                letter-spacing: 0.02em;
                margin-left: $px12;
              }
              input {
                float: right;
                margin-right: $px5;
              }
            }
          }
        }
      }
    }
  }
    }
    }
  .modal-body{
    padding: 0;
  }
  
}
// #language-modal___BV_modal_body_ {
//   .language-selm {
//     top: unset;

//     .edit-profile {
//       .modal-header {
//         padding-bottom: calc(
//           #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
//         );
//         border-bottom: $px1 solid $light-border;
//       }
//     }

//     .modal-dialog,
//     .fade {
//       transition: none !important;
//       transform: none !important;
//       margin: 0;

//       .modal-content {
//         border: none;
//         border-radius: 0.3rem 0.3rem 0 0;
//       }
//     }

//     .modal-body {
//       .radio-btns {
//         ul {
//          /deep/ li {
//             display: block;
//             padding: $px20 0;

//             &:first-child {
//               padding-top: 0;
//             }

//             &:last-child {
//               padding-bottom: 0;
//             }

//            + li {
//               border-top: $px1 solid $light-border;

//               label {
//                 .d-flex {
//                   img {
//                     width: $px18;
//                   }
//                 }
//               }
//             }

//             label {
//               display: block;
//               margin-bottom: 0;

//               .radio_animated {
//                 &:after {
//                   border: $px2 solid $font-color;
//                   top: 0;
//                 }

//                 &:before {
//                   top: $px4;
//                 }

//                 &:checked {
//                   &:after {
//                     border-color: $primary-color;
//                   }
//                 }
//               }

//               .d-flex {
//                 align-items: center;
//               }

//               h6 {
//                 display: inline-block;
//                 margin-bottom: 0;
//                 line-height: $px17;
//                 letter-spacing: 0.02em;
//                 margin-left: $px12;
//               }

//               input {
//                 float: right;
//                 margin-right: $px5;
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// }
.body-rtl {
  .language-selm {
    .radio-btns {
      ul {
        padding-right: 0;
        padding-left: unset;
        li {
          label {
            div {
              h6 {
                margin-left: unset;
                margin-right: .75rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
